import { forwardRef, useId } from "react";

import PropTypes from "prop-types";

const propTypes = {
  SvgComponent: PropTypes.elementType.isRequired,
  title: PropTypes.string,
};

// Icons should either be used an image replacement or as decoration redundant
// to nearby text. These two situations have different accessibility
// implications. In the former case, you should pass a `title` prop to `Icon`,
// which will ultimately act as an ARIA label. In the latter case, you should
// provide no `title` prop to `Icon`, which will make it `aria-hidden`.
const Icon = forwardRef(({ SvgComponent, title, ...props }, ref) => {
  const uniqueId = useId();
  if (!title) {
    return <SvgComponent ref={ref} aria-hidden {...props} />;
  }
  const titleId = `svg-title-${uniqueId}`;
  return (
    <SvgComponent
      ref={ref}
      aria-labelledby={titleId}
      titleId={titleId}
      title={title}
      {...props}
    />
  );
});

Icon.propTypes = propTypes;

export default Icon;
